<div class="p-1" [formGroup]="group()">  
  <div class="key-wrapper d-flex justify-content-between">
    <label *ngIf="!isEditing" for="key" class="form-label text-truncate key-text">{{group().get('key')?.value}}</label>
    <input *ngIf="isEditing" class="w-100 form-control" formControlName="key"/>
    <div class="key-options-wrapper d-flex align-items-center">
      <mat-icon matTooltipPosition="above" matTooltip="Editar nome da chave" class="fa-solid fa-pencil key-option-icon" *ngIf="!isEditing" (click)="isEditing=true"> </mat-icon>               
      <mat-icon matTooltipPosition="above" matTooltip="Confirmar ediçao" class="fa-solid fa-check key-option-icon text-success" *ngIf="isEditing" (click)="isEditing=false"> </mat-icon>               
      <mat-icon matTooltipPosition="above" matTooltip="Remove chave/valor" class="fa-solid fa-trash key-option-icon text-danger" (click)="removeField(index())"></mat-icon>
      <mat-icon *ngIf="group().get('keyFromDependency')?.value"
        matTooltipPosition="above"
        matTooltip="Esta chave foi adicionada/modificada por uma dependência"
        class="fa-solid fa-sitemap key-from-dependency-icon">
      </mat-icon>      
    </div>
  </div> 
  <input formControlName="value" type="text" class="form-control">   
</div>